module.exports = __webpack_public_path__ + "static/3d_datacenter-0324cf497910bcc86472b77152e68a63.png";